module.exports = __webpack_public_path__ + "img/20200508_173542.df01494d.jpg";